/**
 * @desc 审批
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.FinalApproveRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/wms/finalTrialOrder/approve`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
